import { createContext } from 'react'

const AuthContextType = createContext()

export default AuthContextType
